import React from "react";
import "./industries.css";

const sectors = [
  "Financial Services",
  "Manufacturing",
  "Retail",
  "Pharmaceuticals",
  "Government",
  "Education",
];

const Industries = () => {
  return (
    <section className="industries section">
      <div className="industries__container container">
        <span className="industries__label">Industries Served</span>
        <div className="industries__tags">
          {sectors.map((sector) => (
            <span key={sector} className="industries__tag">
              {sector}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;
